import { createContext, useContext } from 'react';
import { IDictionary } from 'models/dictionary';

export interface IDictionaryContext {
  phoneCode: IDictionary[] | null;
  getPhoneCode: () => void;
  civilianPrefix: IDictionary[] | null;
  getCivilianPrefix: () => void;
  gender: IDictionary[] | null;
  getGender: () => void;
  make: IDictionary[] | null;
  getMake: () => void;
  maritalStatus: IDictionary[] | null;
  getMaritalStatus: () => void;
  identificationDocumentType: IDictionary[] | null;
  getIdentificationDocumentType: () => void;
  nationalityAll: IDictionary[] | null;
  getNationalityAll: () => void;
}

export const DictionaryContext = createContext<IDictionaryContext>({} as IDictionaryContext);

export const useDictionary = (): IDictionaryContext => useContext(DictionaryContext);
